import { type Feature } from 'core/domain/Feature'
import { type MarketTag } from 'core/domain/MarketTag'
import { type Mode } from 'core/domain/Mode'
import { type Stop, hasCoordinates } from 'core/domain/Stop'
import { type TruckType } from 'core/domain/Truck'
import { mapStopToString } from 'core/infra/StopMapper'

export const DEFAULT_TRUCK_TYPES: Array<TruckType> = ['DRV', 'FBE', 'RFR']
export const DEFAULT_MARKET_TAGS: Array<MarketTag> = ['contracted', 'shipperdirect', 'spot']
export const DEFAULT_FEATURES: Array<Feature> = [
  'early_appointment',
  'fast_facility',
  'palletized',
  'top_rated_facility',
]
export const DEFAULT_MODES: Array<Mode> = ['FTL', 'PTL']
export const DEFAULT_RADIUS_VALUE = 100

export function getNewLaneState({
  pickup,
  delivery,
  previousPuCoordinates,
  previousDelCoordinates,
}: {
  pickup?: Stop
  delivery?: Stop
  previousPuCoordinates?: string
  previousDelCoordinates?: string
}) {
  const puStop = mapStopToString(pickup)
  const delStop = mapStopToString(delivery)

  let newPuCoordinates, newDelCoordinates

  // Since we have the coordinates into a separate query,
  // we must reassign the coordinates with the previous state
  // after selecting a subsequent PU or DEL.

  if (pickup && hasCoordinates(pickup)) {
    newPuCoordinates = `${pickup.latitude},${pickup.longitude}`
  } else if (pickup) {
    newPuCoordinates = previousPuCoordinates
  }

  if (delivery && hasCoordinates(delivery)) {
    newDelCoordinates = `${delivery.latitude},${delivery.longitude}`
  } else if (delivery) {
    newDelCoordinates = previousDelCoordinates
  }

  // Make sure we only have a radius filter with PU and/or DEL
  const clearRadius = !(pickup ?? delivery)

  return {
    pickup: pickup ? `${puStop}` : undefined,
    pickupCoordinates: newPuCoordinates,
    delivery: delivery ? `${delStop}` : undefined,
    deliveryCoordinates: newDelCoordinates,
    ...(clearRadius && { radius: undefined }),
  }
}
